var map = {
	"./day1.png": 5750,
	"./day10.png": 9846,
	"./day11.png": 8354,
	"./day12.png": 5192,
	"./day13.png": 720,
	"./day14.png": 8698,
	"./day15.png": 3522,
	"./day16.png": 1207,
	"./day17.png": 9663,
	"./day18.png": 8195,
	"./day19.png": 895,
	"./day2.png": 6007,
	"./day20.png": 3459,
	"./day21.png": 5110,
	"./day22.png": 9562,
	"./day23.png": 9766,
	"./day24.png": 9673,
	"./day25.png": 7085,
	"./day26.png": 2464,
	"./day27.png": 9320,
	"./day3.png": 7122,
	"./day4.png": 3609,
	"./day5.png": 5573,
	"./day6.png": 4011,
	"./day7.png": 8228,
	"./day8.png": 7489,
	"./day9.png": 8857
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5835;